import { useFormikContext } from "formik";
import React from "react";
import styles from "./ThemeForm.module.scss";
import Input from "component/atom/forms/input/input/Input";
import TextArea from "component/atom/forms/text-area/TextArea";
import Container from "component/atom/container/Container";
import MultiSelectList from "component/atom/forms/select/multi-select-list/MultiSelectList";
const options = [
  "Logical",
  "Comprehensive",
  "Structured",
  "Patient",
  "Empathetic",
  "Calming",
  "Brief",
  "Clear",
  "Efficient",
  "Supportive",
  "Inspiring",
  "Uplifting",
  "Curious",
  "Reflective",
  "Engaging",
  "Fun",
  "Humorous",
  "Precise",
  "No-nonsense",
  "Factual",
  "Approachable",
  "Conversational",
].map((label) => ({ label, value: label }));

const ThemForm = ({}) => {
  const { values, handleChange, setFieldValue, errors, touched } =
    useFormikContext();

  const handleMultiSelectChange = (event) => {
    const selectedValues = event.target.value;
    setFieldValue("tags", selectedValues.join(", "));
  };

  return (
    <Container className={styles.cont}>
      <Input
        label='Theme Name'
        value={values.responseName}
        name='responseName'
        onChange={handleChange}
        error={errors.responseName}
        placeholder='Enter Name'
      />
      <MultiSelectList
        label='Attitude'
        name='tags'
        value={values.tags ? values.tags.split(", ") : []}
        onChange={handleMultiSelectChange}
        options={options}
        placeholder='Select Attitudes'
        error={errors.tags}
        touched={touched.tags}
      />

      <TextArea
        label='Description'
        value={values.description}
        name='description'
        onChange={handleChange}
        error={errors.description}
        touched={touched.description}
        placeholder='Enter Description'
      />
      <TextArea
        label='Example Response'
        value={values.exampleResponse}
        name='exampleResponse'
        onChange={handleChange}
        error={errors.exampleResponse}
        touched={touched.exampleResponse}
        placeholder='Enter Response'
      />
    </Container>
  );
};

export default ThemForm;
